export const waitForReady = async (
  getTarget,
  {
    timeoutMs = 4000,
    pollIntervalMs = 100,
    requiredMethods = [],
    isReady = (target) => target?.isLoaded === true
  } = {}
) => {
  let elapsedMs = 0;

  while (elapsedMs <= timeoutMs) {
    const target = getTarget?.();
    const hasRequiredMethods = requiredMethods.every(
      (methodName) => typeof target?.[methodName] === 'function'
    );

    if (isReady(target) && hasRequiredMethods) {
      return target;
    }

    if (elapsedMs === timeoutMs) break;

    const delayMs = Math.min(pollIntervalMs, timeoutMs - elapsedMs);
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    elapsedMs += delayMs;
  }

  return null;
};

export const waitForCanvas3DReady = (getCanvas3D, options = {}) =>
  waitForReady(getCanvas3D, options);
